import * as actions from './Actions.js';

import { findContrato, findContratoById } from '../contratos/Actions.js';

import AditivoDetalheInformacao from './AditivoDetalheInformacao.react.js';
import AditivoDetalheItens from './AditivoDetalheItens.react.js';
import Arquivo from '../arquivo/Arquivo.react.js';
import BotaoImprimir from 'portaltransparencia-common/components/BotaoImprimir.react.js';
import CabecalhoEntidade from '../entidades/CabecalhoEntidade.react.js';
import Component from 'react-pure-render/component';
import ContratoDetalheInformacao from '../contratos/ContratoDetalheInformacao.react.js';
import Helmet from 'react-helmet';
import PageHeader from '../components/PageHeader.react.js';
import Panel from 'portaltransparencia-common/components/Panel.react.js';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { downloadArquivo } from '../arquivo/Actions.js';
import { getValueFromUrlSearchParams } from 'portaltransparencia-common/libs/URLUtils.js';

export class AditivoDetalhe extends Component {
  static propTypes = {
    arquivos: PropTypes.object.isRequired,
    aditivo: PropTypes.object.isRequired,
    contrato: PropTypes.object.isRequired,
    location: PropTypes.object.isRequired,
    isIntegradoOxy: PropTypes.bool,
    downloadArquivo: PropTypes.func.isRequired,
    findArquivos: PropTypes.func.isRequired,
    findAditivo: PropTypes.func.isRequired,
    uf: PropTypes.string,
    findContrato: PropTypes.func.isRequired,
    findContratoById: PropTypes.func.isRequired
  };

  componentDidMount() {
    const {
      location,
      findAditivo,
      findArquivos,
      findContrato,
      findContratoById,
      isIntegradoOxy
    } = this.props;

    const entidade = getValueFromUrlSearchParams(location, 'entidade');
    const exercicio = getValueFromUrlSearchParams(location, 'exercicio');
    const numero = getValueFromUrlSearchParams(location, 'numero');
    const idOxy = getValueFromUrlSearchParams(location, 'idOxy');
    const sequencia = getValueFromUrlSearchParams(location, 'sequencia');
    const tipoAto = getValueFromUrlSearchParams(location, 'tipoAto');
    const numeroContrato = getValueFromUrlSearchParams(
      location,
      'numeroContrato'
    );
    const exercicioContrato = getValueFromUrlSearchParams(
      location,
      'exercicioContrato'
    );

    findAditivo(
      entidade,
      exercicio,
      numero,
      sequencia,
      tipoAto,
      exercicioContrato,
      numeroContrato,
      idOxy
    ).then(() => {
      findArquivos(
        entidade,
        exercicio,
        numero,
        sequencia,
        exercicioContrato,
        numeroContrato,
        tipoAto,
        idOxy
      );
    });

    const idContrato = getValueFromUrlSearchParams(location, 'idContrato');
    const contratoCodigo = getValueFromUrlSearchParams(
      location,
      'contratoCodigo'
    );
    const contratoTipoAto = getValueFromUrlSearchParams(
      location,
      'contratoTipoAto'
    );

    if (isIntegradoOxy && idContrato) {
      findContratoById(idContrato);
    } else if (contratoCodigo && contratoTipoAto) {
      findContrato(
        entidade,
        exercicioContrato,
        contratoCodigo,
        contratoTipoAto
      );
    }
  }

  getLinkContrato() {
    const { location, isIntegradoOxy } = this.props;

    const entidade = getValueFromUrlSearchParams(location, 'entidade');
    const exercicioContrato = getValueFromUrlSearchParams(
      location,
      'exercicioContrato'
    );
    const idContrato = getValueFromUrlSearchParams(location, 'idContrato');
    const contratoCodigo = getValueFromUrlSearchParams(
      location,
      'contratoCodigo'
    );
    const contratoTipoAto = getValueFromUrlSearchParams(
      location,
      'contratoTipoAto'
    );

    if (isIntegradoOxy && idContrato) {
      return `/contratos/detalhes?id=${idContrato}`;
    }

    if (contratoCodigo && contratoTipoAto) {
      return `/contratos/detalhes?entidade=${entidade}&exercicio=${exercicioContrato}&contrato=${contratoCodigo}&tipoAto=${contratoTipoAto}`;
    }

    return undefined;
  }

  render() {
    const {
      aditivo,
      contrato,
      downloadArquivo,
      arquivos,
      uf,
      isIntegradoOxy
    } = this.props;

    const arquivosList = arquivos
      .map(item => item.get('arquivoCompras'))
      .filter(item => !!item);

    const numeroContrato = aditivo.get('numeroContrato');
    const exercicioContrato = aditivo.get('exercicioContrato');

    return (
      <div>
        <Helmet title={`Aditivo - #${aditivo.get('numeroAditivo')}`} />

        <BotaoImprimir />

        <PageHeader
          location={this.props.location}
          menuRouteOverride="contratos"
          textoDetalhe={`Contrato: ${numeroContrato}/${exercicioContrato}`}
          linkDetalhe={this.getLinkContrato()}
          detalheAdicional={`Aditivo ${aditivo.get(
            'numeroAditivo'
          )}/${aditivo.get('sequencia')}`}
        />

        <CabecalhoEntidade />

        {!contrato.isEmpty() && (
          <ContratoDetalheInformacao contrato={contrato} />
        )}

        <AditivoDetalheInformacao aditivo={aditivo} />

        <AditivoDetalheItens
          aditivo={aditivo}
          isIntegradoOxy={isIntegradoOxy}
          uf={uf}
        />

        <Panel isTable tableResponsive title="Anexos">
          <Arquivo arquivos={arquivosList} onDownload={downloadArquivo} />
        </Panel>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    aditivo: state.aditivo.get('aditivo'),
    arquivos: state.aditivo.get('arquivos'),
    contrato: state.contrato.get('contrato'),
    uf: state.entidade.getIn(['entidadeSelecionada', 'uf']),
    isIntegradoOxy: state.entidade.getIn([
      'configuracoesGerais',
      'isIntegradoOxy'
    ])
  };
}

const allActions = {
  ...actions,
  downloadArquivo,
  findContrato,
  findContratoById
};

export default connect(mapStateToProps, allActions)(AditivoDetalhe);
